import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-green-900 to-yellow-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/fa77cf8cc3bbd77c4d454e1d51d6ad11/08c0c974fe3f0f7d94db22878d008646.png" 
                alt="Yellow Atlas Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-yellow-400 to-green-400 bg-clip-text text-transparent">Yellow Atlas Consulting</span>
            </div>
            <p className="text-gray-200 mb-6 max-w-md leading-relaxed">
              Leading IT consulting firm specializing in Cloud solutions, Cybersecurity, and Digital Transformation services in Manchester, UK.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/yellowatlas" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-green-500 rounded-full flex items-center justify-center text-white hover:shadow-lg hover:scale-110 transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-green-500 rounded-full flex items-center justify-center text-white hover:shadow-lg hover:scale-110 transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gradient-to-r from-yellow-400 to-green-500 rounded-full flex items-center justify-center text-white hover:shadow-lg hover:scale-110 transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-yellow-400">Quick Links</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-200 hover:text-yellow-400 transition-colors duration-300 cursor-pointer flex items-center group"><i className="ri-arrow-right-line mr-2 group-hover:translate-x-1 transition-transform duration-300"></i>About Us</Link></li>
              <li><Link to="/services" className="text-gray-200 hover:text-yellow-400 transition-colors duration-300 cursor-pointer flex items-center group"><i className="ri-arrow-right-line mr-2 group-hover:translate-x-1 transition-transform duration-300"></i>Services</Link></li>
              <li><Link to="/projects" className="text-gray-200 hover:text-yellow-400 transition-colors duration-300 cursor-pointer flex items-center group"><i className="ri-arrow-right-line mr-2 group-hover:translate-x-1 transition-transform duration-300"></i>Projects</Link></li>
              <li><Link to="/careers" className="text-gray-200 hover:text-yellow-400 transition-colors duration-300 cursor-pointer flex items-center group"><i className="ri-arrow-right-line mr-2 group-hover:translate-x-1 transition-transform duration-300"></i>Careers</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-green-400">Contact</h3>
            <div className="space-y-4 text-gray-200">
              <p className="flex items-center group">
                <div className="w-8 h-8 bg-gradient-to-r from-yellow-400 to-green-500 rounded-full flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-map-pin-line text-sm text-white"></i>
                </div>
                Caidan House, Altrincham, WA14 1TD
              </p>
              <p className="flex items-center group">
                <div className="w-8 h-8 bg-gradient-to-r from-yellow-400 to-green-500 rounded-full flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-phone-line text-sm text-white"></i>
                </div>
                +44 0330 223 7340
              </p>
              <p className="flex items-center group">
                <div className="w-8 h-8 bg-gradient-to-r from-yellow-400 to-green-500 rounded-full flex items-center justify-center mr-3 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-mail-line text-sm text-white"></i>
                </div>
                hello@yellowatlas.co.uk
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm">
            © 2026 Yellow Atlas Consulting Ltd. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-300 hover:text-yellow-400 text-sm transition-colors duration-300 cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-gray-300 hover:text-yellow-400 text-sm transition-colors duration-300 cursor-pointer">
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
